import { Typography } from 'components';
import { useTranslations } from 'next-intl';
import { useConfig } from 'providers/InvoicesProviders/useConfig';
import { useTaxId } from 'providers/InvoicesProviders/useTaxId';
import { dateExtensive } from 'utils/time/dateExtensive';

const SplitAddressLines = ({ address, title }) => (
  <>
    <Typography variant="regular6" className="text-quaternary-800">
      {title}
    </Typography>

    {address?.split('\n').map((addressLine, i) => {
      if (i === 0)
        return (
          <Typography key={addressLine} variant="medium5">
            {addressLine}
          </Typography>
        );

      return (
        <Typography key={addressLine} variant="regular5" className="leading-[16px]">
          {addressLine}
        </Typography>
      );
    })}
  </>
);

export default function InvoiceData({
  invoice: { id, issuedAt, dueDate, poCode, customerNumber, fromAddress, toAddress }
}) {
  const t = useTranslations();

  const { data: config } = useConfig();
  const { data: client } = useTaxId();

  return (
    <>
      <div className="invoice__paper__from_to">
        <div className="invoice__paper__to flex flex-col gap-4">
          <div className="flex flex-col">
            <Typography variant="regular6" className="text-quaternary-800">
              {t('billing.invoice_date')}
            </Typography>
            <Typography variant="medium5">{dateExtensive(issuedAt)}</Typography>
          </div>
        </div>
        <div className="invoice__paper__from flex flex-col gap-4">
          {dueDate && (
            <div className="flex flex-col">
              <Typography variant="regular6" className="text-quaternary-800">
                {t('billing.due_date')}
              </Typography>
              <Typography variant="medium5">{dueDate ? dateExtensive(dueDate) : null}</Typography>
            </div>
          )}
        </div>
      </div>
      <div className="invoice__paper__from_to">
        <div className="invoice__paper__to flex flex-col gap-4">
          <div className="flex flex-col">
            <SplitAddressLines address={toAddress} title={t('billing.from')} />
          </div>
        </div>
        <div className="invoice__paper__from flex flex-col gap-4">
          <div className="flex flex-col">
            <SplitAddressLines address={fromAddress} title={t('billing.to')} />
          </div>
        </div>
      </div>
      <div className="invoice__paper__from_to">
        <div className="invoice__paper__to flex flex-col gap-2">
          <div className="flex flex-col">
            <Typography variant="regular6" className="text-quaternary-800">
              {t('billing.invoice_number')}
            </Typography>
            <Typography variant="medium5">{id}</Typography>
          </div>
          {client?.taxid && (
            <div className="flex flex-col">
              <Typography variant="regular6" className="text-quaternary-800">
                {t('invoices.index.tax_id')}
              </Typography>
              <Typography variant="medium5">{client?.taxid}</Typography>
            </div>
          )}
          {poCode && (
            <div className="flex flex-col">
              <Typography variant="regular6" className="text-quaternary-800">
                {t('billing.po_code')}
              </Typography>
              <Typography variant="medium5">{poCode}</Typography>
            </div>
          )}
        </div>
        <div className="invoice__paper__from flex flex-col gap-2">
          {customerNumber && (
            <div className="flex flex-col">
              <Typography variant="regular6" className="text-quaternary-800">
                {t('billing.customer_number')}
              </Typography>
              <Typography variant="medium5">{customerNumber}</Typography>
            </div>
          )}
          <div className="flex flex-col">
            <Typography variant="regular6" className="text-quaternary-800">
              {t('invoices.index.vat')}
            </Typography>
            <Typography variant="medium5">{config?.vat}</Typography>
          </div>
          <div className="flex flex-col">
            <Typography variant="regular6" className="text-quaternary-800">
              {t('invoices.index.kvk')}
            </Typography>
            <Typography variant="medium5">{config?.kvk}</Typography>
          </div>
        </div>
      </div>
    </>
  );
}
